var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { connect } from 'mini-store';
var TableHeaderRow = /** @class */ (function (_super) {
    __extends(TableHeaderRow, _super);
    function TableHeaderRow(props) {
        return _super.call(this, props) || this;
    }
    TableHeaderRow.prototype.render = function () {
        var _a = this.props, row = _a.row, height = _a.height;
        var trStyle = {
            height: height,
        };
        return (React.createElement("tr", { style: trStyle }, row.map(function (cell, i) {
            var column = cell.column, children = cell.children;
            var align = column.align, className = column.className, ellipsis = column.ellipsis, colSpan = column.colSpan, rowSpan = column.rowSpan, title = column.title;
            // 对齐方式
            var thStyle = {};
            if (align) {
                thStyle.textAlign = align;
            }
            // 排序手型
            if (column.sorter) {
                thStyle.cursor = 'pointer';
            }
            var thClassName = (className || '') + " " + (ellipsis ? 'ellipsis' : '');
            var thProps = {
                style: __assign({}, thStyle),
                colSpan: colSpan,
                rowSpan: rowSpan,
                className: undefined,
                title: undefined,
            };
            if (thClassName !== ' ') {
                thProps.className = thClassName;
            }
            else {
                delete thProps.className;
            }
            if (ellipsis) {
                thProps.title = title;
            }
            else {
                delete thProps.title;
            }
            return (React.createElement("th", __assign({ key: i }, thProps, { 
                // @ts-ignore
                onClick: column.onHeaderCell }), children));
        })));
    };
    return TableHeaderRow;
}(Component));
function getRowHeight(state, props) {
    var fixedColumnsHeadRowsHeight = state.fixedColumnsHeadRowsHeight;
    var rows = props.rows, fixed = props.fixed;
    var headerHeight = fixedColumnsHeadRowsHeight[0];
    if (!fixed) {
        return null;
    }
    if (headerHeight) {
        if (headerHeight === 'auto') {
            return 'auto';
        }
        return headerHeight / rows.length;
    }
    return null;
}
export default connect(function (state, props) { return ({
    height: getRowHeight(state, props),
}); })(TableHeaderRow);
